import { LogoProps } from './types';

const QodoText = ({ className = '', size = 24 }: LogoProps) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 59 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.3335 5.75781C18.8346 5.75781 15.9912 8.55965 15.9912 11.9981C15.9912 15.4365 18.8389 18.2384 22.3335 18.2384C25.8282 18.2384 28.6759 15.4365 28.6759 11.9981C28.6759 8.55965 25.8282 5.75781 22.3335 5.75781ZM22.3335 15.5915C20.3202 15.5915 18.6814 13.9791 18.6814 11.9981C18.6814 10.0171 20.3202 8.40469 22.3335 8.40469C24.3469 8.40469 25.9857 10.0171 25.9857 11.9981C25.9857 13.9791 24.3469 15.5915 22.3335 15.5915Z"
      fill="#7968FA"
    />
    <path
      d="M52.6534 5.75781C49.1545 5.75781 46.311 8.55965 46.311 11.9981C46.311 15.4365 49.1587 18.2384 52.6534 18.2384C56.1481 18.2384 58.9957 15.4365 58.9957 11.9981C58.9957 8.55965 56.1481 5.75781 52.6534 5.75781ZM52.6534 15.5915C50.64 15.5915 49.0012 13.9791 49.0012 11.9981C49.0012 10.0171 50.64 8.40469 52.6534 8.40469C54.6668 8.40469 56.3056 10.0171 56.3056 11.9981C56.3056 13.9791 54.6668 15.5915 52.6534 15.5915Z"
      fill="#7968FA"
    />
    <path
      d="M10.8237 6.90091C9.7893 6.18055 8.5336 5.75337 7.17149 5.75337C3.67255 5.75337 0.829132 8.55521 0.829132 11.9936C0.829132 15.4321 3.67681 18.2339 7.17149 18.2339C8.52935 18.2339 9.7893 17.8067 10.8237 17.0864V23.6784H13.5181V4.48438H10.8237V6.90091ZM7.17149 15.5912C5.15811 15.5912 3.51931 13.9788 3.51931 11.9978C3.51931 10.0169 5.15811 8.40444 7.17149 8.40444C9.18486 8.40444 10.8237 10.0169 10.8237 11.9978C10.8237 13.9788 9.18486 15.5912 7.17149 15.5912Z"
      fill="#7968FA"
    />
    <path
      d="M41.1435 6.90211C40.1092 6.18176 38.8535 5.75457 37.4913 5.75457C33.9924 5.75457 31.149 8.55641 31.149 11.9948C31.149 15.4333 33.9967 18.2351 37.4913 18.2351C38.8492 18.2351 40.1092 17.8079 41.1435 17.0876V19.4245H43.8379V0.230469H41.1435V6.90211ZM37.4956 15.5924C35.4822 15.5924 33.8434 13.98 33.8434 11.999C33.8434 10.0181 35.4822 8.40564 37.4956 8.40564C39.509 8.40564 41.1478 10.0181 41.1478 11.999C41.1478 13.98 39.509 15.5924 37.4956 15.5924Z"
      fill="#7968FA"
    />
  </svg>
);

export default QodoText;
